import React, { Component } from 'react';

const styles = {
  cell: {
    padding: 15,
  },
};

export default class PageItemHeader extends Component {
  typeDataFormat(type) {
    let icon = '';
    if (type === 'youtube') {
      icon = 'video.png';
    } else if (type === 'article') {
      icon = 'article.png';
    }
    return (
      <div className="entry-item-type-icon"><img className="fit-height" role="presentation" src={`/assets/img/icons/${icon}`} /></div>
    );
  }
  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ ...styles.cell, flex: 1 }}>Esport</div>
        <div style={{ ...styles.cell, flex: 1 }}>Type</div>
        <div style={{ ...styles.cell, flex: 10 }}>Title</div>
        <div style={{ ...styles.cell, flex: 1.5 }}>Session</div>
        <div style={{ ...styles.cell, flex: 1.5 }}>AvgTime</div>
        <div style={{ ...styles.cell, flex: 1.5 }}>PageViews</div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/cms/dashboard/PageItemHeader.js